import FinishMessage from './FinishMessage.vue';

export default FinishMessage;



// WEBPACK FOOTER //
// ./src/components/parts/catalog/card/components/request/components/finishMessage/index.ts